import { responsiveMaxWidth } from 'common-ui-components/src/vtj/theme/helpers'
import media from 'common-ui-components/src/vtj/theme/media'
import { styled } from 'styled-components'
import { Block, Paragraph } from 'suomifi-ui-components'

export const StyledBlock = styled(Block)`
  align-self: center;
  width: 100%;
  padding-top: ${(props) => props.theme.spacing.xxl};
  ${responsiveMaxWidth()}

  ${media.mobileContent} {
    padding: ${(props) => props.theme.spacing.xxl}
      ${(props) => props.theme.spacing.xl} 0;
  }
`

export const StyledParagraph = styled(Paragraph)`
  padding-top: ${(props) => props.theme.spacing.m};
`

export const HiddenSpan = styled('span')`
  visibility: hidden;
`
